import { render, staticRenderFns } from "./tos.vue?vue&type=template&id=991ed852&scoped=true"
import script from "./tos.vue?vue&type=script&lang=js"
export * from "./tos.vue?vue&type=script&lang=js"
import style0 from "./tos.vue?vue&type=style&index=0&id=991ed852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991ed852",
  null
  
)

export default component.exports